import { gql } from "@apollo/client";
import { ContaminationDeclarationValidityFields } from "../fragments/contaminationDeclarationValidity";

/**
 * Fetched fresh on every click of the print button, with `fetchPolicy: "no-cache"`.
 *
 * `file` is non-null exactly when `validity.isPrintable` is true, and its `link`
 * is presigned, bound to the calling user and valid for about an hour. `File` is
 * a normalized entity shared across queries, so caching this result would hand
 * an expiring URL to every other screen that reads the same file.
 *
 * `declarationAccepted` and `validity` travel along so the caller can write the
 * authoritative state back into the cache when the declaration turned out to be
 * no longer printable — no second round trip for the 409 case.
 */
export const ContaminationDeclarationPrintFile = gql`
    query ContaminationDeclarationPrintFile ($id: ID!) {
        contaminationDeclaration (contaminationDeclarationId: $id) {
            id
            declarationAccepted
            validity {
                ...ContaminationDeclarationValidityFields
            }
            file {
                id
                basename
                link
            }
        }
    }
    ${ContaminationDeclarationValidityFields}
`;
